'use strict';

var self = module.exports = {

    onConsent: function (preference) {
        console.log('onConsent', preference);
        setTimeout(function () {
            if (preference.consent) {
                dataLayer.push({
                    'event': 'cookie_law_accepted',
                    'consense_marketing': true,
                    'anonymizeIp': true
                });
            } else if (preference.purposes) {
                if (preference.purposes[5]) {
                    dataLayer.push({
                        'event': 'cookie_law_accepted',
                        'consense_marketing': true,
                        'anonymizeIp': false
                    });
                } else if (preference.purposes[4]) {
                    dataLayer.push({
                        'event': 'cookie_law_accepted',
                        'consense_marketing': false,
                        'anonymizeIp': false
                    });
                } else {
                    dataLayer.push({
                        'event': 'cookie_law_accepted',
                        'consense_marketing': false,
                        'anonymizeIp': true
                    });
                }

            }
        }, 500);
    }

}
